var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7802 15.833L14.6649 12.7177C14.5243 12.5771 14.3337 12.499 14.1337 12.499H13.6244C14.4868 11.396 14.9992 10.0086 14.9992 8.49937C14.9992 4.90909 12.0901 2 8.49985 2C4.90958 2 2.00049 4.90909 2.00049 8.49937C2.00049 12.0896 4.90958 14.9987 8.49985 14.9987C10.0091 14.9987 11.3964 14.4863 12.4995 13.6239V14.1332C12.4995 14.3332 12.5776 14.5238 12.7182 14.6644L15.8335 17.7797C16.1272 18.0734 16.6022 18.0734 16.8928 17.7797L17.7771 16.8954C18.0708 16.6017 18.0708 16.1267 17.7802 15.833ZM8.49985 12.499C6.29069 12.499 4.50024 10.7116 4.50024 8.49937C4.50024 6.29021 6.28757 4.49976 8.49985 4.49976C10.709 4.49976 12.4995 6.28708 12.4995 8.49937C12.4995 10.7085 10.7121 12.499 8.49985 12.499Z",
    fill: "currentColor",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearch);
export default __webpack_public_path__ + "static/media/ic-search.0955ddfb6a3f94b7e75141ae85e0dcd4.svg";
export { ForwardRef as ReactComponent };